import { createContext, ReactNode, useContext, useState } from "react";
import { CurrentView, HullData } from "../types/IPitchProps";
import { ChemistryPlayerPositions, FormationData, IOption, TeamChemistry } from "../types/IOption";
import { IDisabledButtonsState, IInjuryEvents, IMatches, IMatchInfo, IMatchLevelEvents } from "../types/ITimeline";
import { IRiskMap } from "../types/IRiskMapData";

interface IPitchWidgetContextType {
  selectedTeam: number;
  setSelectedTeam: React.Dispatch<React.SetStateAction<number>>;
  selectedTeamLabel: string;
  setSelectedTeamLabel: React.Dispatch<React.SetStateAction<string>>;
  currentView: CurrentView;
  setCurrentView: React.Dispatch<React.SetStateAction<CurrentView>>;
  currentPlayView: CurrentView;
  setCurrentPlayView: React.Dispatch<React.SetStateAction<CurrentView>>;
  positionResults: ChemistryPlayerPositions[];
  setPositionResults: React.Dispatch<React.SetStateAction<ChemistryPlayerPositions[]>>;
  formationData: FormationData[];
  setFormationData: React.Dispatch<React.SetStateAction<FormationData[]>>;
  teamChemistry: TeamChemistry[];
  setTeamChemistry: React.Dispatch<React.SetStateAction<TeamChemistry[]>>;
  initialPositionResults: ChemistryPlayerPositions[];
  setInitialPositionResults : React.Dispatch<React.SetStateAction<ChemistryPlayerPositions[]>>;
  selectedFormation: number;
  setSelectedFormation: React.Dispatch<React.SetStateAction<number>>;
  passNetworkPlayers: ChemistryPlayerPositions[];
  setPassNetworkPlayers: React.Dispatch<React.SetStateAction<ChemistryPlayerPositions[]>>;
  passNetworkPlayerPasses: any[];
  setPassNetworkPlayerPasses: React.Dispatch<React.SetStateAction<any[]>>;
  PNFormationData: FormationData[];
  setPNFormationData: React.Dispatch<React.SetStateAction<FormationData[]>>;
  selectedPNFormation: number;
  setSelectedPNFormation: React.Dispatch<React.SetStateAction<number>>;
  selectedMatch: number;
  setSelectedMatch: React.Dispatch<React.SetStateAction<number>>;
  disabledButtons: IDisabledButtonsState;
  setDisabledButtons: React.Dispatch<React.SetStateAction<IDisabledButtonsState>>;
  direction: string;
  setDirection: React.Dispatch<React.SetStateAction<string>>;
  groupIndex: number;
  setGroupIndex: React.Dispatch<React.SetStateAction<number>>;
  selectedSeasonId: number;
  setSelectedSeasonId: React.Dispatch<React.SetStateAction<number>>;
  seasonName: string;
  setSeasonName: React.Dispatch<React.SetStateAction<string>>;
  seasonData: IOption[];
  setSeasonData: React.Dispatch<React.SetStateAction<IOption[]>>;
  zoomLevelId: 1 | 2 | 3 | 4;
  setZoomLevelId: React.Dispatch<React.SetStateAction<1 | 2 | 3 | 4>>;
  timeLineTag: string;
  setTimeLineTag: React.Dispatch<React.SetStateAction<string>>;
  injuryEvents: IInjuryEvents | undefined;
  setInjuryEvents: React.Dispatch<React.SetStateAction<IInjuryEvents | undefined>>;
  matchLevelEvents: IMatchLevelEvents[];
  setMatchLevelEvents: React.Dispatch<React.SetStateAction<IMatchLevelEvents[]>>;
  matchEndTime: number;
  setMatchEndTime: React.Dispatch<React.SetStateAction<number>>;
  matchDate: string;
  setMatchDate: React.Dispatch<React.SetStateAction<string>>;
  matchInfo: IMatchInfo | undefined;
  setMatchInfo: React.Dispatch<React.SetStateAction<IMatchInfo | undefined>>;
  previousMatchId: number;
  setPreviousMatchId: React.Dispatch<React.SetStateAction<number>>;
  displayedMatches: IMatches[];
  setDisplayedMatches: React.Dispatch<React.SetStateAction<IMatches[]>>;
  matches: any[];
  setMatches: React.Dispatch<React.SetStateAction<any[]>>;
  riskMapData: IRiskMap[];
  setRiskMapData: React.Dispatch<React.SetStateAction<IRiskMap[]>>;
  hullData: HullData;
  setHullData: React.Dispatch<React.SetStateAction<HullData>>;
  isIndividualChemistry: boolean;
  setIsIndividualChemistry: React.Dispatch<React.SetStateAction<boolean>>;
  isIndividualPassing: boolean;
  setIsIndividualPassing: React.Dispatch<React.SetStateAction<boolean>>;
  isSwapActive: boolean;
  setIsSwapActive: React.Dispatch<React.SetStateAction<boolean>>;
  pnSwapActive: boolean;
  setPNSwapActive: React.Dispatch<React.SetStateAction<boolean>>;
  isChemistryDataNotEnough: boolean;
  setIsChemistryDataNotEnough: React.Dispatch<React.SetStateAction<boolean>>;
  individualHullPlayer: number;
  setIndividualHullPlayer: React.Dispatch<React.SetStateAction<number>>;
  thirdOfSeason: string;
  setThirdOfSeason: React.Dispatch<React.SetStateAction<string>>;
  drawCount: number;
  setDrawCount: React.Dispatch<React.SetStateAction<number>>;
  lossCount: number;
  setLossCount: React.Dispatch<React.SetStateAction<number>>;
  winCount: number;
  setWinCount: React.Dispatch<React.SetStateAction<number>>;
  swappedPlayerClub: string | undefined;
  setSwappedPlayerClub: React.Dispatch<React.SetStateAction<string | undefined>>;
  otherClubPlayer: number;
  setOtherClubPlayer: React.Dispatch<React.SetStateAction<number>>;
  swappedPositionResults: ChemistryPlayerPositions[];
  setSwappedPositionResults: React.Dispatch<React.SetStateAction<ChemistryPlayerPositions[]>>;
  swappedTeamChemistry: TeamChemistry[];
  setSwappedTeamChemistry: React.Dispatch<React.SetStateAction<TeamChemistry[]>>;
  currentClubLogo: string | undefined;
  setCurrentClubLogo: React.Dispatch<React.SetStateAction<string | undefined>>;
  playerToSwap: number;
  setPlayerToSwap: React.Dispatch<React.SetStateAction<number>>;
  playerToSwapWith: number;
  setPlayerToSwapWith: React.Dispatch<React.SetStateAction<number>>;
  currentPlayerView: number;
  setCurrentPlayerView: React.Dispatch<React.SetStateAction<number>>;
  overallSFScore: number;
  setOverallSFScore: React.Dispatch<React.SetStateAction<number>>;
  newOverallSFScore: number;
  setNewOverallSFScore: React.Dispatch<React.SetStateAction<number>>;
  avgAge: number;
  setAvgAge: React.Dispatch<React.SetStateAction<number>>;
  newAvgAge: number;
  setNewAvgAge: React.Dispatch<React.SetStateAction<number>>;
  attackContribution: number;
  setAttackContribution: React.Dispatch<React.SetStateAction<number>>;
  newAttackContribution: number;
  setNewAttackContribution: React.Dispatch<React.SetStateAction<number>>;
  ppda: number;
  setPPDA: React.Dispatch<React.SetStateAction<number>>;
  newPPDA: number;
  setNewPPDA: React.Dispatch<React.SetStateAction<number>>;
}

const PitchWidgetContext = createContext<Partial<IPitchWidgetContextType>>({});

export const usePitchWidgetContext = (): IPitchWidgetContextType => {
  const context = useContext(PitchWidgetContext);
  if (!context) {
    throw new Error("usePitchWidgetContext must be used within a PitchWidgetContextProvider");
  }
  return context as IPitchWidgetContextType;
};

export const PitchWidgetContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [selectedTeam, setSelectedTeam] = useState<number>(0);
  const [selectedTeamLabel, setSelectedTeamLabel] = useState<string>("");
  const [currentView, setCurrentView] = useState<CurrentView>("systemFit");
  const [currentPlayView, setCurrentPlayView] = useState<CurrentView>("minus");
  const [positionResults, setPositionResults] = useState<ChemistryPlayerPositions[]>([]);
  const [formationData, setFormationData] = useState<FormationData[]>([]);
  const [teamChemistry, setTeamChemistry] = useState<TeamChemistry[]>([]);
  const [initialPositionResults, setInitialPositionResults] = useState<ChemistryPlayerPositions[]>([]);
  const [swappedPositionResults, setSwappedPositionResults] = useState<ChemistryPlayerPositions[]>([]);
  const [swappedTeamChemistry, setSwappedTeamChemistry] = useState<TeamChemistry[]>([]);
  const [selectedFormation, setSelectedFormation] = useState<number>(0);
  const [passNetworkPlayers, setPassNetworkPlayers] = useState<ChemistryPlayerPositions[]>([]);
  const [passNetworkPlayerPasses, setPassNetworkPlayerPasses] = useState<any[]>([]);
  const [PNFormationData, setPNFormationData] = useState<FormationData[]>([]);
  const [selectedPNFormation, setSelectedPNFormation] = useState<number>(0);
  const [selectedMatch, setSelectedMatch] = useState<number>(0);
  const [disabledButtons, setDisabledButtons] = useState<IDisabledButtonsState>({
    play: true,
    previous: true,
    zoomOut: true,
    zoomIn: true,
    next: true,
  });
  const [direction, setDirection] = useState<string>("previous");
  const [groupIndex, setGroupIndex] = useState<number>(0);
  const [selectedSeasonId, setSelectedSeasonId] = useState<number>(0);
  const [seasonName, setSeasonName] = useState<string>("");
  const [seasonData, setSeasonData] = useState<IOption[]>([]);
  const [zoomLevelId, setZoomLevelId] = useState<1 | 2 | 3 | 4>(4);
  const [timeLineTag, setTimeLineTag] = useState<string>("");
  const [injuryEvents, setInjuryEvents] = useState<IInjuryEvents>();
  const [matchLevelEvents, setMatchLevelEvents] = useState<IMatchLevelEvents[]>([]);
  const [matchEndTime, setMatchEndTime] = useState<number>(0);
  const [matchDate, setMatchDate] = useState<string>("");
  const [matchInfo, setMatchInfo] = useState<IMatchInfo>();
  const [previousMatchId, setPreviousMatchId] = useState<number>(0);
  const [displayedMatches, setDisplayedMatches] = useState<IMatches[]>([]);
  const [matches, setMatches] = useState<any[]>([]);
  const [riskMapData, setRiskMapData] = useState<IRiskMap[]>([]);
  const [hullData, setHullData] = useState<HullData>([]);
  const [isIndividualChemistry, setIsIndividualChemistry] = useState<boolean>(false);
  const [isIndividualPassing, setIsIndividualPassing] = useState<boolean>(false);
  const [isSwapActive, setIsSwapActive] = useState<boolean>(false);
  const [pnSwapActive, setPNSwapActive] = useState<boolean>(false);
  const [isChemistryDataNotEnough, setIsChemistryDataNotEnough] = useState<boolean>(false);
  const [individualHullPlayer, setIndividualHullPlayer] = useState<number>(0);
  const [thirdOfSeason, setThirdOfSeason] = useState<string>("FinalThird");
  const [drawCount, setDrawCount] = useState<number>(0);
  const [lossCount, setLossCount] = useState<number>(0);
  const [winCount, setWinCount] = useState<number>(0);
  const [swappedPlayerClub, setSwappedPlayerClub] = useState<string>();
  const [otherClubPlayer, setOtherClubPlayer] = useState<number>(0);
  const [currentClubLogo, setCurrentClubLogo] = useState<string>();
  const [playerToSwap, setPlayerToSwap] = useState<number>(0);
  const [playerToSwapWith, setPlayerToSwapWith] = useState<number>(0);
  const [currentPlayerView, setCurrentPlayerView] = useState<number>(0);
  const [overallSFScore, setOverallSFScore] = useState<number>(0);
  const [newOverallSFScore, setNewOverallSFScore] = useState<number>(0);
  const [avgAge, setAvgAge] = useState<number>(0);
  const [newAvgAge, setNewAvgAge] = useState<number>(0);
  const [attackContribution, setAttackContribution] = useState<number>(0);
  const [newAttackContribution, setNewAttackContribution] = useState<number>(0);
  const [ppda, setPPDA] = useState<number>(0);
  const [newPPDA, setNewPPDA] = useState<number>(0);

  return (
    <PitchWidgetContext.Provider
      value={{
        selectedTeam,
        setSelectedTeam,
        selectedTeamLabel,
        setSelectedTeamLabel,
        currentView,
        setCurrentView,
        currentPlayView,
        setCurrentPlayView,
        positionResults,
        setPositionResults,
        formationData,
        setFormationData,
        teamChemistry,
        setTeamChemistry,
        initialPositionResults, setInitialPositionResults,
        selectedFormation,
        setSelectedFormation,
        passNetworkPlayers,
        setPassNetworkPlayers,
        passNetworkPlayerPasses,
        setPassNetworkPlayerPasses,
        PNFormationData,
        setPNFormationData,
        selectedPNFormation,
        setSelectedPNFormation,
        selectedMatch,
        setSelectedMatch,
        disabledButtons,
        setDisabledButtons,
        direction,
        setDirection,
        groupIndex,
        setGroupIndex,
        selectedSeasonId,
        setSelectedSeasonId,
        seasonName,
        setSeasonName,
        seasonData,
        setSeasonData,
        zoomLevelId,
        setZoomLevelId,
        timeLineTag,
        setTimeLineTag,
        injuryEvents,
        setInjuryEvents,
        matchLevelEvents,
        setMatchLevelEvents,
        matchEndTime,
        setMatchEndTime,
        matchDate,
        setMatchDate,
        matchInfo,
        setMatchInfo,
        previousMatchId,
        setPreviousMatchId,
        displayedMatches,
        setDisplayedMatches,
        matches,
        setMatches,
        riskMapData,
        setRiskMapData,
        hullData,
        setHullData,
        isIndividualChemistry,
        setIsIndividualChemistry,
        isIndividualPassing,
        setIsIndividualPassing,
        isSwapActive,
        setIsSwapActive,
        pnSwapActive,
        setPNSwapActive,
        isChemistryDataNotEnough,
        setIsChemistryDataNotEnough,
        individualHullPlayer,
        setIndividualHullPlayer,
        thirdOfSeason,
        setThirdOfSeason,
        drawCount,
        setDrawCount,
        lossCount,
        setLossCount,
        winCount,
        setWinCount,
        swappedPlayerClub,
        setSwappedPlayerClub,
        otherClubPlayer,
        setOtherClubPlayer,
        swappedPositionResults,
        setSwappedPositionResults,
        swappedTeamChemistry,
        setSwappedTeamChemistry,
        currentClubLogo,
        setCurrentClubLogo,
        playerToSwap,
        setPlayerToSwap,
        playerToSwapWith,
        setPlayerToSwapWith,
        currentPlayerView,
        setCurrentPlayerView,
        overallSFScore,
        setOverallSFScore,
        newOverallSFScore,
        setNewOverallSFScore,
        avgAge,
        setAvgAge,
        newAvgAge,
        setNewAvgAge,
        attackContribution,
        setAttackContribution,
        newAttackContribution,
        setNewAttackContribution,
        ppda,
        setPPDA,
        newPPDA,
        setNewPPDA,
      }}
    >
      {children}
    </PitchWidgetContext.Provider>
  );
};
